module.exports = __webpack_public_path__ + "static/media/arena_won.99ffa4e1.mp3";